import React from 'react';
import SEO from '../components/common/SEO';
import InquiryFormSection from "../components/inquiry/InquiryFormSection";
import InquiryQuoteSection from "../components/inquiry/InquiryQuoteSection";

const Inquiry = () => {
  return (
    <div>
      <SEO
        title="Inquire & Get Started"
        description="Ready for a new website? Get in touch with SeaSalt Creative to discuss your project and get custom setup details."
        keywords="inquire web design, contact seasalt creative, start website project, custom web design inquiry"
      />
      <div className="w-full bg-[#f9f9f5] min-h-screen text-[#1C1917] px-[28px] sm:px-8 md:px-12 lg:px-16 pt-8 pb-0 overflow-hidden">
        <div className="max-w-7xl mx-auto">
          <InquiryFormSection />
        </div>

        <InquiryQuoteSection />
      </div>
    </div>
  );
};

export default Inquiry;